const map = {
	"./Lillia.png": 9792,
	"./Moose.png": 612,
	"./blob.gif": 8209,
	"./chatbubble.png": 603,
	"./deer.png": 7915,
	"./github.png": 2038,
	"./horse.png": 8580,
	"./jerry.png": 7059,
	"./league.webp": 5038,
	"./linkedin.png": 1661,
	"./mail.png": 9926,
	"./reindeer.png": 1225,
	"./resume.png": 6466,
	"./sus.webp": 7084,
	"./upgradeImages/Arrow.webp": 6973,
	"./upgradeImages/Blackhole.webp": 8321,
	"./upgradeImages/Fire.png": 7118,
	"./upgradeImages/LilliaP.webp": 5259,
	"./upgradeImages/Mine.webp": 6027,
	"./upgradeImages/MoonThrow.jpg": 1229,
	"./upgradeImages/Orbital.webp": 3161,
	"./upgradeImages/ReindeerIcon.png": 9643,
	"./upgradeImages/Shotgun.webp": 198,
	"./upgradeImages/Skull.png": 495,
	"./upgradeImages/Trap.png": 5479,
	"./upgradeImages/earth.png": 7092,
	"./upgradeImages/horse.png": 1871,
	"./upgradeImages/lilliaIcon.webp": 8740,
	"./upgradeImages/mooseIcon.png": 5700
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;